/** `/_/episodes/{spaceId}/{episodeId}`: the link of the "new episode" e-mail (F-178). */
export const EPISODE_LINK_PREFIX = '/_/episodes/'

export const isEpisodeLinkPath = (path: string): boolean => /^\/_\/episodes\/[^/]+\/[^/?#]+/.test(path)

export const episodeLinkOf = (path: string): { spaceId: string; episodeId: string } | null => {
  const match = /^\/_\/episodes\/([^/]+)\/([^/?#]+)/.exec(path)
  return match ? { spaceId: decodeURIComponent(match[1]), episodeId: decodeURIComponent(match[2]) } : null
}
